import React, { Component } from "react";
import "../../css/AiRpCommonAssets.css";
import "../../css/AiRpTrialEnded.css";

import BasicDialogV2 from '../modules/dialogs/BasicDialogV2';
import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';

import http from "../modules/api";

class AiRpTrialEnded extends Component {
  constructor(props) {
    super(props);

    this.state = {
      is_contact_input_dialog_show: false,
      
      basic_dialog_show_state: false,
      basic_dialog_content: "",
      basic_dialog_button_list: [],

      save_dialog_show_state: false,
      save_dialog_content: "",
      save_dialog_button_list: [],

      expired_type: props.expiredType,
      free_order_state: props.freeOrderState
    };
  }

  componentDidMount() {
    this.setState({
      expired_type: this.props.expiredType,
      free_order_state: this.props.freeOrderState
    });

    this.fetchDashboard();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.expiredType !== this.props.expiredType) {
      this.setState({
        expired_type: this.props.expiredType,
      });
    }
    if (prevProps.freeOrderState !== this.props.freeOrderState) {
      this.setState({
        free_order_state: this.props.freeOrderState,
      });
    }
  }

  /**
   * 통계 API 호출
   */
  fetchDashboard = () => {
    http.get("/rest/shop/ai/rp/stats", {
      params: {
        is_group_by_iframe_page_id: true,
        s: "1900-01-07", // start,
        e: "2999-12-31", // end,
      }
    })
    .then(res => {
      // 서버가 Map으로 내려준 구조 그대로 저장
      this.setState({
        dashboard: res.data,
      });
    })
    .catch(err => {
      this.setState({ loading: false, sync: false });
      alert("추천 성과 조회 에러");
    });
  };

  sendAiRpContactInfoBtnCirform(button_name = "홈/견적요청하기 버튼 신청") {
      const body = {
        user_name: "", // 이름은 따로 입력받지 않고, 빈값으로 전달
        email: "", // 이메일은 따로 입력받지 않고, 빈값으로 전달
        tel_no: "", // 연락처는 따로 입력받지 않고, 빈값으로 전달
        ai_algorithm_cd: "", // ai_algorithm_cd는 따로 입력받지 않고, 빈값으로 전달
        button_name: button_name ? button_name : "홈/견적요청하기 버튼 신청", // 버튼 이름 추가
      }
      const config = {
              headers: {
                  'content-type': 'application/json;'
              }
          }
      http.post("/rest/shop/inserUserAiRpContactInfo", body , config)
      .then(res => {
        console.log("추천상품 가격 상담받기 신청 완료!!!");
              this.setState({is_contact_input_dialog_show: false}, () => {
                  this.setState({
                      basic_dialog_show_state: true,
                      basic_dialog_content: 
                        button_name == "홈/견적요청하기 버튼 신청" 
                          ? "AI추천 견적 요청이 정상적으로 접수되었습니다. 담당자가 확인 후 연락 드리겠습니다."
                          : button_name == "홈/AI추천 도입 상담하기"
                            ? "AI추천 도입 상담 요청이 정상적으로 접수되었습니다. 담당자가 확인 후 연락 드리겠습니다."
                            : "AI추천 결과 자료 요청이 정상적으로 접수되었습니다. 담당자가 확인 후 연락 드리겠습니다."
                      ,
                      basic_dialog_button_list: [
                          {
                              title: "확인",
                              type: "1",
                              event_method: () => {
                                  //팝업 닫기
                                  this.setState({ basic_dialog_show_state: false });
                              }
                          }
                      ]
                  });
              });
      }).catch(error => {
        console.log("추천상품 가격 상담받기 신청 실패!!!");
        console.log(error);
              this.setState({is_contact_input_dialog_show: false});
      });
    }

  /**
   * 숫자 포맷
   */
  formatNumber = (v) => {
    if (v == null) return '0';
    const n = Number(v);
    if (isNaN(n)) return String(v);
    return n.toLocaleString('ko-KR');
  };

  /**
   * 증감 상태(up/down/same) 만들기
   * - 예: 매출 증감률 rev_chg_pct 를 사용
   */
  buildChgStatus = (pct) => {
    const n = Number(pct);
    if (!isFinite(n) || isNaN(n)) return { status: 'same', rate: 0 };
    if (n > 0) return { status: 'up', rate: n };
    if (n < 0) return { status: 'down', rate: n };
    return { status: 'same', rate: 0 };
  };

  render() {
    const { expired_type, free_order_state, dashboard } = this.state;

    // KPI 가공
    const kpi = dashboard && dashboard.kpi ? dashboard.kpi : null;

    const cur_pv = kpi ? kpi.cur_pv : 0;
    const cur_imp = kpi ? kpi.cur_imp : 0;
    const cur_click = kpi ? kpi.cur_click : 0;

    // 주문/매출은 “구매일 기준 + last-click 7일”로 채운 order_cnt/order_amount
    const cur_order = kpi ? kpi.cur_order : 0;
    const cur_rev = kpi ? kpi.cur_rev : 0;

    // CTR/CVR
    const cur_ctr_pct = kpi ? kpi.cur_ctr_pct : 0;
    const cur_cvr_pct = kpi ? kpi.cur_cvr_pct : 0;

    const revChgPct = kpi ? kpi.rev_chg_pct : 0;
    const revChg = this.buildChgStatus(revChgPct);

    const orderStatsDaily = dashboard && dashboard.orderStatsDaily ? dashboard.orderStatsDaily : null;

    const total_order_amount = orderStatsDaily ? orderStatsDaily.total_order_amount ? orderStatsDaily.total_order_amount : 0 : 0;

    // 도달률(= imp/pv)
    const reachPct = (Number(cur_pv) > 0) ? (Number(cur_imp) / Number(cur_pv) * 100) : 0;

    // Slot Table
    const slotTable = dashboard && dashboard.slotTable ? dashboard.slotTable : [];

    const robomd_detail_page_cur_cvr_pct =
      slotTable.find(slot => slot.iframe_page_id === "robomd_ai_detail_page")?.cvr_pct || 0;
    const robomd_main_page_cur_cvr_pct =
      slotTable.find(slot => slot.iframe_page_id === "robomd_ai_main_page")?.cvr_pct || 0;
    const robomd_order_complete_page_cur_cvr_pct =
      slotTable.find(slot => slot.iframe_page_id === "robomd_ai_order_complete_page")?.cvr_pct || 0;
    const robomd_cart_page_cur_cvr_pct =
      slotTable.find(slot => slot.iframe_page_id === "robomd_ai_cart_page")?.cvr_pct || 0;
    return (
    <>
    <div id="common-page-wrapper">
      <div className="ai-rp-trial-ended">
        <div className="layout-wrapper">
          <main className="main-content">
            <div className="container">
              <div className="page-header">
                <h1>
                  {
                    expired_type === "FREE_TRIAL_EXPIRED"
                    ? "무료 이용 기간이 종료되었습니다."
                    : "유료 이용 기간이 종료되었습니다."
                  }
                </h1>
                <p style={{fontWeight:700}}>
                  이용 종료일: {free_order_state ? free_order_state.end_date_format : "N/A"}
                </p>
                <p>
                  {
                    expired_type === "FREE_TRIAL_EXPIRED"
                    ? "그동안 RoboMD가 쇼핑몰에 만들어낸 놀라운 추천 성과를 확인하고 정식 도입을 결정해 주세요."
                    : "그동안 RoboMD가 쇼핑몰에 만들어낸 놀라운 추천 성과를 확인하고 재결제를 결정해 주세요."
                  }
                </p>
              </div>
              <section className="card metrics-card">
                <div className="metrics-header">
                  <div>
                    <h2>
                      <i className="fa-solid fa-medal" style={{"color": "var(--mint-dark)"}}></i>
                      최종 AI추천 성과
                    </h2>
                    <p>
                      이용 기간 동안 발생한 누적 데이터이며, 
                      {
                        expired_type === "FREE_TRIAL_EXPIRED" ? "정식 도입 시" : "재결제 시"
                      } 
                      끊김 없이 계속 누적됩니다.
                    </p>
                  </div>
                  <button className="btn-more" onClick={() => {window.open("/shop/ai/rp/dashboard", "_blank")}}>
                    더보기
                    <i className="fa-solid fa-chevron-right"></i>
                  </button>
                </div>
                <div className="metrics-grid">
                  <div className="metric-item">
                    <p className="metric-label">
                      최종 누적 페이지뷰
                    </p>
                    <p className="metric-value num-font">
                      {this.formatNumber(cur_pv)}
                      <span className="metric-unit">
                        뷰
                      </span>
                    </p>
                  </div>
                  <div className="metric-item">
                    <p className="metric-label">
                      최종 실 노출수
                    </p>
                    <p className="metric-value num-font">
                      {this.formatNumber(cur_imp)}
                      <span className="metric-unit">
                        건
                      </span>
                    </p>
                  </div>
                  <div className="metric-item">
                    <p className="metric-label">
                      추천 통한 구매건수
                    </p>
                    <p className="metric-value num-font">
                      {Number(cur_click) === 0 ? 0 : this.formatNumber(cur_order)}
                      <span className="metric-unit">
                        건
                      </span>
                    </p>
                  </div>
                  <div className="metric-item">
                    <p className="metric-label">
                      최종 구매 전환율
                    </p>
                    <p className="metric-value num-font">
                      {Number(cur_click) === 0 ? 0 : this.formatNumber(
                        isNaN(cur_cvr_pct) || !isFinite(cur_cvr_pct) ? 0 : cur_cvr_pct.toFixed(2),
                        2
                      )}
                      <span className="metric-unit">
                        %
                      </span>
                    </p>
                  </div>
                  <div className="metric-item">
                    <p className="metric-label">
                      기여 매출액
                    </p>
                    <p className="metric-value num-font">
                      {Number(cur_click) === 0 ? 0 : this.formatNumber(cur_rev)}
                      <span className="metric-unit">
                        원
                      </span>
                    </p>
                  </div>
                  <div className="metric-item">
                    <p className="metric-label">
                      기여 매출율
                    </p>
                    <p className="metric-value highlight num-font">
                      {this.formatNumber(
                        Number(total_order_amount) === 0 || Number(cur_click) === 0
                          ? 0
                          : (Number(cur_rev) / Number(total_order_amount) * 100).toFixed(2),
                        2
                      )}
                      <span className="metric-unit">
                        %
                      </span>
                    </p>
                  </div>
                  {/* <div className="metric-item">
                    <p className="metric-label">
                      기여 매출
                    </p>
                    <p className="metric-value highlight num-font">
                      {this.formatNumber(cur_rev)}
                      <span className="metric-unit">
                        원
                      </span>
                    </p>
                  </div> */}
                </div>
              </section>
              <section className="card status-banner">
                <div className="status-left">
                  <div className="status-icon-wrapper">
                    <i className="fa-solid fa-pause"></i>
                  </div>
                  <div className="status-text">
                    <h2>
                      {
                        expired_type === "FREE_TRIAL_EXPIRED"
                        ? "무료 이용 기간 종료 — AI 추천 위젯 작동 일시 중지"
                        : "유료 이용 기간 종료 — AI 추천 위젯 작동 일시 중지"
                      }
                      {/* <span className="badge-warning"> */}
                      <span className="badge-deactive">
                        {
                          expired_type === "FREE_TRIAL_EXPIRED"
                          ? "도입 대기 중"
                          : "결제 대기 중"
                        }
                      </span>
                    </h2>
                    <p>
                      쇼핑몰 내의 모든 AI 추천 위젯 노출이 일시적으로 멈췄습니다.
                      <strong style={{marginLeft: "4px"}}>
                        {
                          expired_type === "FREE_TRIAL_EXPIRED"
                          ? "정식 도입을 진행하시면 추가 설정 없이 추천이 즉시 재개됩니다."
                          : "결제가 완료되는 즉시 추천이 자동으로 재개됩니다."
                        }
                      </strong>
                    </p>
                  </div>
                </div>
                <div className="status-right">
                  <button className="btn-action-target" onClick={() => this.sendAiRpContactInfoBtnCirform()}>
                    <i className="fa-solid fa-headset"></i>
                    견적 요청하기
                  </button>
                </div>
              </section>
              <section>
                <h2 className="section-title">
                  작동 대기 중인 AI 추천 영역
                </h2>
                <div className="widget-grid">
                  <div className="widget-card paused">
                    <div className="w-header">
                      <div className="w-icon">
                        <i className="fa-regular fa-file-lines"></i>
                      </div>
                      {/* <div className="status-badge-paused">
                        <i className="fa-solid fa-pause"></i>
                        이용 종료
                      </div> */}
                    </div>
                    <div>
                      <h3 className="w-title">
                        상품 상세 (Item-Based CF)
                      </h3>
                      <p className="w-desc">
                        "이 상품을 본 고객이 함께 산 상품"을 딥러닝으로 매칭하여 추가 구매를 유도합니다.
                      </p>
                    </div>
                    <div className="w-footer">
                      <div className="w-effect">
                        <span className="e-label">
                          최종 추천 구매 전환율
                        </span>
                        <span className="e-val num-font" style={{"color": "var(--gray-text)"}}>
                          { robomd_detail_page_cur_cvr_pct ? this.formatNumber(robomd_detail_page_cur_cvr_pct, 2) : 0 }%
                        </span>
                      </div>
                      <button className="btn-install">
                        <i className="fa-solid fa-pause"></i>
                        이용 종료
                      </button>
                    </div>
                  </div>
                  <div className="widget-card paused">
                    <div className="w-header">
                      <div className="w-icon">
                        <i className="fa-solid fa-cart-shopping"></i>
                      </div>
                      {/* <div className="status-badge-paused">
                        <i className="fa-solid fa-pause"></i>
                        이용 종료
                      </div> */}
                    </div>
                    <div>
                      <h3 className="w-title">
                        장바구니 (Cross-Sell)
                      </h3>
                      <p className="w-desc">
                        브랜드 상관없이 장바구니 상품과 연관성이 높은 아이템을 제안하여 동시 구매율을 높입니다.
                      </p>
                    </div>
                    <div className="w-footer">
                      <div className="w-effect">
                        <span className="e-label">
                          최종 추천 구매 전환율
                        </span>
                        <span className="e-val num-font" style={{"color": "var(--gray-text)"}}>
                          {robomd_cart_page_cur_cvr_pct ? this.formatNumber(robomd_cart_page_cur_cvr_pct, 2) : 0}%
                        </span>
                      </div>
                      <button className="btn-install">
                        <i className="fa-solid fa-pause"></i>
                        이용 종료
                      </button>
                    </div>
                  </div>
                  <div className="widget-card paused">
                    <div className="w-header">
                      <div className="w-icon">
                        <i className="fa-solid fa-circle-check"></i>
                      </div>
                      {/* <div className="status-badge-paused">
                        <i className="fa-solid fa-pause"></i>
                        이용 종료
                      </div> */}
                    </div>
                    <div>
                      <h3 className="w-title">
                        구매완료 (재구매 유도)
                      </h3>
                      <p className="w-desc">
                        결제를 방금 마친 고객의 취향을 분석해 연관 상품을 노출하여 즉각적인 추가 결제를 유도합니다.
                      </p>
                    </div>
                    <div className="w-footer">
                      <div className="w-effect">
                        <span className="e-label">
                          최종 추천 구매 전환율
                        </span>
                        <span className="e-val num-font" style={{"color": "var(--gray-text)"}}>
                          {robomd_order_complete_page_cur_cvr_pct ? this.formatNumber(robomd_order_complete_page_cur_cvr_pct, 2) : 0}%
                        </span>
                      </div>
                      <button className="btn-install">
                        <i className="fa-solid fa-pause"></i>
                        이용 종료
                      </button>
                    </div>
                  </div>
                  <div className="widget-card paused">
                    <div className="w-header">
                      <div className="w-icon">
                        <i className="fa-solid fa-house"></i>
                      </div>
                      {/* <div className="status-badge-paused">
                        <i className="fa-solid fa-pause"></i>
                        이용 종료
                      </div> */}
                    </div>
                    <div>
                      <h3 className="w-title">
                        메인 홈 (Best Seller)
                      </h3>
                      <p className="w-desc">
                        방문자의 관심 키워드와 연관된 상품을 분석하여 가장 구매 확률이 높은 상품을 보여줍니다.
                      </p>
                    </div>
                    <div className="w-footer">
                      <div className="w-effect">
                        <span className="e-label">
                          최종 추천 구매 전환율
                        </span>
                        <span className="e-val num-font" style={{"color": "var(--gray-text)"}}>
                          {robomd_main_page_cur_cvr_pct ? this.formatNumber(robomd_main_page_cur_cvr_pct, 2) : 0}%
                        </span>
                      </div>
                      <button className="btn-install">
                        <i className="fa-solid fa-pause"></i>
                        이용 종료
                      </button>
                    </div>
                  </div>
                </div>
              </section>
              <section className="card onboarding-card" id="finalActionArea">
                <div className="step-container">
                  <div className="step-line"></div>
                  <div className="step-line-active" style={{"width": "80%"}}></div>
                  <div className="step-item active">
                    <div className="step-circle">
                      <i className="fa-solid fa-check"></i>
                    </div>
                    <div className="step-name">
                      회원 가입
                    </div>
                  </div>
                  <div className="step-item active">
                    <div className="step-circle">
                      <i className="fa-solid fa-check"></i>
                    </div>
                    <div className="step-name">
                      AI타겟뷰 앱 설치
                    </div>
                  </div>
                  <div className="step-item active">
                    <div className="step-circle">
                      <i className="fa-solid fa-check"></i>
                    </div>
                    <div className="step-name">
                      AI 추천 설치 완료
                    </div>
                  </div>
                  <div className="step-item active">
                    <div className="step-circle">
                      <i className="fa-solid fa-check"></i>
                    </div>
                    <div className="step-name">
                      무료 이용 완료
                    </div>
                  </div>
                  <div className="step-item current">
                    <div className="step-circle num-font">
                      5
                    </div>
                    <div className="step-name">
                      정식 도입 결정
                    </div>
                  </div>
                </div>
                <div className="action-area">
                  <div className="button-group">
                    <button className="btn-action-primary" onClick={(e) => this.sendAiRpContactInfoBtnCirform("홈/AI추천 도입 상담하기")}>
                      <i className="fa-solid fa-headset"></i>
                      AI추천 도입 상담하기
                    </button>
                    <button className="btn-action-secondary" onClick={(e) => this.sendAiRpContactInfoBtnCirform("홈/AI추천 결과 자료 요청하기")}>
                      <i className="fa-regular fa-file-pdf"></i>
                      AI추천 결과 자료 요청하기
                    </button>
                  </div>
                  <p className="helper-text" id="finalHelperText">
                    추가 폼 작성 없이
                    <strong>
                      가입 시 등록된 연락처 정보로 즉시 접수
                    </strong>
                    됩니다.
                    <br />
                    요청 시 담당자가 확인 후, 영업일 기준 24시간 이내에 상세히 안내해 드리겠습니다.
                  </p>
                </div>
              </section>
            </div>
          </main>
        </div>
      </div>
    </div>
    {/* 왼쪽 또는 오른쪽 영역 저장시 나오는 다이얼로그 */
      (this.state.save_dialog_show_state === true)
      ? <SaveDialogV2
        content={this.state.save_dialog_content}
        button_list={this.state.save_dialog_button_list}
      />
      : ''
    }
            {/* 기본 안내 다이얼로그 */
      (this.state.basic_dialog_show_state === true)
      ? <BasicDialogV2
        content={this.state.basic_dialog_content}
        button_list={this.state.basic_dialog_button_list}
      />
      : ''
    }
    </>
    );
  }
}

export default AiRpTrialEnded;
